
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6ztoV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $6031640bc482303d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Russian
var $6031640bc482303d$export$2e2bcd8739ae039 = {
    'space-directory.filters.personal.v2': "\u041B\u0438\u0447\u043D\u044B\u0435",
    'space-directory.filters.starred': "\u041E\u0442\u043C\u0435\u0447\u0435\u043D\u043D\u044B\u0435"
};

});


//# sourceMappingURL=ru.a1a5ace5.js.map
